import React, { useEffect } from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { LookInsideCarousel } from './components/LookInsideCarousel';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SummaryTable } from './components/SummaryTable';
import { SystemSection } from './components/SystemSection';
import { UrgencySection } from './components/UrgencySection';
import { productShortName } from './data/offer';
const pageDescription = 'A visual technical reference to fire science, detection and alarm, sprinklers, water supply and fire pumps, special-hazard suppression and ITM. 6 professional volumes, 5 exclusive bonuses and instant access.';
export function App() {
  useEffect(() => {
    document.title = productShortName;
    const setMeta = (attr: 'name' | 'property', key: string, content: string) => {
      let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attr, key);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };
    setMeta('name', 'description', pageDescription);
    setMeta('property', 'og:title', productShortName);
    setMeta('property', 'og:description', pageDescription);
  }, []);
  return <div className="min-h-screen w-full overflow-hidden bg-background font-sans text-muted antialiased" data-id="element-0" data-mp="nxww9i4xheu4">
      <MetaPixel data-id="element-1" data-mp="36hwt7ylgu1r" />
      <main data-id="element-2" data-mp="35yq6nee9s31">
        <Hero data-id="element-3" data-mp="35oxgs1yt6tn" />
        <LookInsideCarousel data-id="element-4" data-mp="356sn718lka4" />
        <ProblemSection data-id="element-5" data-mp="38kxclxdi5kq" />
        <SystemSection data-id="element-6" data-mp="3ud1hdeu8fyd9" />
        <ModulesSection data-id="element-7" data-mp="3udkn7x6lywax" />
        <BonusSection data-id="element-8" data-mp="3uc9k7zkzlskv" />
        <UrgencySection data-id="element-9" data-mp="3uevui6z9im6s" />
        <PricingSection data-id="element-10" data-mp="d4e4tqw8j8vn" />
        <GuaranteeSection data-id="element-11" data-mp="d3mkxdc02zl7" />
        <FAQ data-id="element-12" data-mp="d3wdn8ofjkul" />
        <ClosingSection data-id="element-13" data-mp="d2l7513lnyzs" />
        <SummaryTable data-id="element-14" data-mp="85uk1ttdo34v" />
        <FinalCta data-id="element-15" data-mp="85b8cuubmaza" />
      </main>
      <Footer data-id="element-16" data-mp="86cmx9ajpflr" />
      <PurchaseNotification data-id="element-17" data-mp="83i6rtykegy5" />
    </div>;
}